const PLAYER_REPORT = {
  GET_PLAYER_REPORTS: 'wbo/admin/player-reports' as 'wbo/admin/player-reports',
}

export default PLAYER_REPORT
